import type { HelpFile } from '../../types/help'
import { AdminTestIds } from '../../../testids/AdminTestIds'

export const adminHelp: HelpFile = {
  docPage: '/docs/admin/overview',
  texts: {
    [AdminTestIds.adminWelcomeCard]:
      'Admin section landing page — pick a tool from the sidebar: roles, role assignments, connectors, error logs, and notification log.',
    [AdminTestIds.failureBadge]:
      'Number of failed background jobs that require attention — opens the execution list filtered to failures.',
  },
}
